import * as React from 'react';
import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
} from '../extensions';
import { Editor } from '@tiptap/react';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { MenuDropdown } from '../components/MenuDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   UndoButton,
   RedoButton,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
} from '../components/buttons';

import type { TiptapExtension } from '../tiptap';

export const GuideIntroExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
];

export const GuideIntroMenuBar = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapMenubar>
         <BoldButton editor={editor} />
         <ItalicButton editor={editor} />
         <CodeButton editor={editor} />
         <LinkButton editor={editor} />
         <MenuSeparator />
         <MenuDropdown editor={editor} />
         <MenuSeparator />
         <BulletListButton editor={editor} />
         <OrderedListButton editor={editor} />
         <UnindentButton editor={editor} />
         <IndentButton editor={editor} />
         <MenuSeparator />
         <UndoButton editor={editor} />
         <RedoButton editor={editor} />
      </TiptapMenubar>
   );
};
